<!--
  ~ Copyright (c) 2025 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->
<div class='panel-container batch-panel'>
    <div class="filter-row">
        <div class="custom-dropdown-container">
            <div class="custom-dropdown">
                <textarea
                    class="custom-dropdown-input"
                    spellcheck="false"
                    [(ngModel)]="currentPartInput"
                    (ngModelChange)="onSearch()"
                    [placeholder]="partsLoading ? 'Retrieving...' : ''">
                </textarea>
            </div>
        </div>
        <label
            class="regex-toggle"
            title="Match part names with regular expressions, one pattern per line (case insensitive, unanchored)"
        >
            <input type="checkbox" [(ngModel)]="useRegex" (ngModelChange)="onRegexToggle()" />
            Regex
        </label>
        <div class="controls">
            <button
                *ngIf='recoveredJob'
                class="btn btn-link p-0"
                (click)="recoverJob()"
                title="Recover interrupted job"
            >
                Recover Interrupted Job
            </button>
            <button
                class="btn btn-link p-0"
                (click)="reprocessDatum()"
                title="Reprocess all datum values for the selected parts"
            >
                Reprocess
            </button>
        </div>
    </div>
    <div class="regex-errors" *ngIf="regexErrors.length">
        <div *ngFor="let error of regexErrors">{{error}}</div>
    </div>
    <div class="parts-table mat-elevation-z8">
        <div class="parts-row parts-header">
            <div class="cell cell-select">
                <mat-checkbox [checked]='allSelected' (change)='update($event.checked)'></mat-checkbox>
            </div>
            <div class="cell cell-name">Name</div>
            <div class="cell cell-messages">Messages</div>
            <div class="cell cell-status">Status</div>
        </div>
        <!-- Only the visible rows are rendered -->
        <cdk-virtual-scroll-viewport
            class="parts-viewport"
            [itemSize]="rowHeight"
            minBufferPx="240"
            maxBufferPx="480"
        >
            <div class="parts-row" *cdkVirtualFor="let element of filteredPartsList; trackBy: trackByName">
                <div class="cell cell-select">
                    <mat-checkbox
                        [checked]='element.selected'
                        (change)='update($event.checked, element)'
                    ></mat-checkbox>
                </div>
                <div class="cell cell-name" [title]="element.name">{{element.name}}</div>
                <div class="cell cell-messages">{{element.messages?.join(", ")}}</div>
                <div class="cell cell-status">
                    <mat-spinner [diameter]="16" *ngIf="element.status === 'PENDING'"></mat-spinner>
                    <i class="icon-status glyphicon glyphicon-ok" *ngIf="element.status === 'DONE'"></i>
                    <i class="icon-status glyphicon glyphicon-remove" *ngIf="element.status === 'ERROR'"></i>
                </div>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
</div>
